import React, { Component } from 'react';

import { withStyles } from '@material-ui/core/styles';
import { LinearProgress } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import { Checkbox, SnackbarContent, VSpacer } from 'sm-react-components';

import Error from '../components/Error';
import * as requests from '../../infrastructure/requests';

const styles = theme => ({
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
        maxWidth: 300,
    },
    inlineHeader: {
        display: 'inline-block',
        paddingRight: '10px'
    },
    startDateSelector: {
        display: 'inline-block'
    }
});

class Statistics extends Component {
    state = {
        statistics: undefined,
        filters: {
            keys: undefined,
            requests: [],
            statuses: undefined,
            startDate: new Date('2018-08-01'),
            endDate: undefined
        },
        loading: false,
        error: undefined,
        startDateOffset: 90 * 24 * 3600
    }

    componentDidMount() {
        this.handleStartDateOffset(this.state.startDateOffset);
    }

    load = async () => {
        try {
            this.setState({
                loading: true
            });
            const filters = this.mergeFilters(this.state.filters, this.props.filters);
            this.setState({
                statistics: await requests.getLogStats(
                    filters.keys,
                    filters.requests,
                    filters.statuses,
                    filters.startDate,
                    filters.endDate
                ),
                loading: false
            });
        } catch (error) {
            this.setState({
                loading: false,
                error: error.message
            });
        }
    }

    mergeFilters(filters1, filters2) {
        return {
            ...filters1,
            ...filters2
        };
    }

    handleStartDateOffset = startDateOffset => {
        if (startDateOffset === null) return;
        this.setState({
            startDateOffset,
            filters: {
                ...this.state.filters,
                startDate: new Date(new Date().getTime() - startDateOffset * 1000)
            }
        }, this.load);
    }

    handleRequestsFilterUpdate = event => {
        this.setState({
            ...this.state,
            filters: {
                ...this.state.filters,
                requests: event.target.value
            }
        }, this.load);
    }

    render() {
        const { loading, error, statistics, startDateOffset, filters } = this.state;
        const { classes, children } = this.props;
        return (
            <React.Fragment>
                {loading && <LinearProgress />}
                {error && <Error message={error} />}
                <div>
                    <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="select-multiple-checkbox">Requests</InputLabel>
                        <Select
                            multiple
                            value={filters.requests}
                            onChange={this.handleRequestsFilterUpdate}
                            input={<Input id="select-multiple-checkbox" />}
                            renderValue={selected => selected.join(', ')}
                        // MenuProps={MenuProps}
                        >
                            {['optimizerV1', 'optimizerV1-get'].map(request => (
                                <MenuItem key={request} value={request}>
                                    <Checkbox checked={filters.requests.indexOf(request) > -1} />
                                    <ListItemText primary={request} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="select-multiple-checkbox">Since</InputLabel>
                        <Select
                            value={startDateOffset}
                            native
                            onChange={event => this.handleStartDateOffset(event.target.value)}
                            className={classes.startDateSelector}
                        >
                            <option value={7 * 24 * 3600}>7 days</option>
                            <option value={14 * 24 * 3600}>14 days</option>
                            <option value={30 * 24 * 3600}>30 days</option>
                            <option value={90 * 24 * 3600}>90 days</option>
                        </Select>
                    </FormControl>
                </div>
                <VSpacer medium />
                {(statistics !== undefined && statistics.size === 0) &&
                    <SnackbarContent
                        message='No request recorded yet.'
                    />
                }
                {(statistics !== undefined && statistics.size > 0) &&
                    <Grid container spacing={16}>
                        {React.Children.map(children, ch => React.cloneElement(ch, { statistics }))}
                    </Grid>
                }
            </React.Fragment>
        );
    }
}

export default withStyles(styles)(Statistics);